import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
    Box, 
    IconButton, 
    Tooltip, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography 
} from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import LogoutIcon from '@mui/icons-material/Logout';
import { authService } from '../services/api';

const Navigation: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

    const handleLogout = async () => {
        try {
            await authService.logout();
            localStorage.removeItem('token');
            navigate('/login');
        } catch (error) {
            console.error('Ошибка при выходе:', error);
        }
        setOpenLogoutDialog(false);
    };

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '64px',
                    backgroundColor: '#424242',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    pt: 2,
                    gap: 2,
                    zIndex: 1200,
                    boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Tooltip title="Идеи" placement="right">
                    <IconButton 
                        onClick={() => navigate('/ideas')}
                        sx={{
                            width: 40,
                            height: 40,
                            color: 'white',
                            backgroundColor: location.pathname === '/ideas' ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            },
                        }}
                    >
                        <ViewListIcon />
                    </IconButton>
                </Tooltip>

                <Box sx={{ flexGrow: 1 }} />

                <Tooltip title="Выйти" placement="right">
                    <IconButton 
                        onClick={() => setOpenLogoutDialog(true)}
                        sx={{
                            width: 40,
                            height: 40,
                            color: 'white',
                            mb: 2,
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            },
                        }}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Dialog 
                open={openLogoutDialog} 
                onClose={() => setOpenLogoutDialog(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Подтверждение выхода</DialogTitle>
                <DialogContent>
                    <Typography>
                        Вы уверены, что хотите выйти из системы?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => setOpenLogoutDialog(false)}
                        color="inherit"
                    >
                        Отмена
                    </Button>
                    <Button 
                        onClick={handleLogout}
                        variant="contained"
                        color="primary"
                        autoFocus
                    >
                        Выйти
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Navigation; 